import * as React from "react";
import { Navigation } from "@/ReactComponents/Navigation/navigation";

const NavigationView = props => {
    return <Navigation {...props} />;
};

export default NavigationView;
